const VideoChatVideoTrackType = {
  camera: 'camera',
  screenShare: 'screenShare',
};

export default VideoChatVideoTrackType;
